import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Como o Método LDA funciona?",
    answer: "O Método LDA é um sistema completo de libertação que combina técnicas de neurociência, psicologia comportamental e suporte em grupo. Trabalhamos não apenas para parar as apostas, mas para reconstruir sua vida de forma sólida e sustentável.",
  },
  {
    question: "Quanto tempo leva para ver resultados?",
    answer: "A maioria das pessoas relata mudanças significativas nas primeiras 48 horas. O programa completo é desenhado para criar transformações profundas e duradouras em 90 dias, mas você começará a sentir os benefícios desde o primeiro dia.",
  },
  {
    question: "E se eu já tentei parar antes e não consegui?",
    answer: "Isso é muito comum. O vício em apostas não é falta de força de vontade, é um problema complexo que precisa de uma solução especializada. O Método LDA foi criado justamente para pessoas que já tentaram outras abordagens sem sucesso.",
  },
  {
    question: "O método funciona mesmo para casos graves?",
    answer: "Sim! O Método LDA foi testado e aprovado por pessoas em situações extremas - dívidas de centenas de milhares, famílias destruídas, tentativas de suicídio. Se você está disposto a se comprometer com o processo, podemos ajudá-lo.",
  },
  {
    question: "Preciso contar para outras pessoas que estou fazendo?",
    answer: "Não. Você tem total privacidade e confidencialidade. Muitos alunos preferem fazer o programa de forma discreta e só compartilham com familiares quando já estão vendo resultados. A decisão é 100% sua.",
  },
  {
    question: "Existe garantia?",
    answer: "Sim! Oferecemos garantia incondicional de 7 dias. Se você seguir o método e não ver resultados reais, devolvemos 100% do seu investimento, sem perguntas ou burocracias.",
  },
];

export const FAQ = () => {
  return (
    <section className="py-20 relative" id="faq">
      <div className="container px-4">
        <div className="text-center mb-16 animate-slide-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Perguntas{" "}
            <span className="bg-gradient-accent bg-clip-text text-transparent">
              Frequentes
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Tire suas dúvidas sobre o Método LDA
          </p>
        </div>

        <div className="max-w-3xl mx-auto animate-scale-in">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="backdrop-blur-xl bg-card/40 rounded-xl px-6 border border-primary/20 hover:border-primary/40 transition-all duration-300 hover:shadow-[0_8px_32px_rgba(100,192,242,0.2)]"
              >
                <AccordionTrigger className="text-left text-lg font-semibold hover:text-accent transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
